import ElementLoader from "components/ElementLoader";
import { getByExecutionTypeName } from "components/Icon/Icon";
import Widget from "components/Layout/Widget";
import RecordLabel from "components/RecordLabel";
import { ExecutionStatusBadge } from "components/StatusBadge/ExecutionStatusBadge";
import { TimeAgo } from "components/TimeAgo/TimeAgo";
import { getSingleStatFetching } from "containers/Stats/Stats.selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import "./LatestList.scss";

const LatestList = ({ config, resourceData, stats }) => {
    const statDataFetching = useSelector(getSingleStatFetching);

    if (statDataFetching?.includes(config?.selector) || !stats) {
        return <ElementLoader />;
    }

    const data = config?.dto({ resourceData, stats });

    if (data?.length === 0) return <Widget.Empty />;

    return (
        <div>
            {data?.map((item) => (
                <div className="latestList-item" key={item?.id}>
                    <div className="flex justify-between">
                        <TimeAgo
                            className="text-sm text-dark-grey text-bold"
                            datetime={item?.created_at}
                        />
                        <ExecutionStatusBadge data={item} size="" />
                    </div>
                    <div className="latestList-item__label">
                        <RecordLabel
                            key={`stat${item?.created_at}`}
                            name={item?.name}
                            link={item?.link}
                            iconByType={item?.type}
                            icon={getByExecutionTypeName(item?.type?.toLowerCase())}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

LatestList.defaultProps = {
    resourceData: {},
    stats: {},
};

LatestList.propTypes = {
    config: PropTypes.oneOfType([PropTypes.object]).isRequired,
    resourceData: PropTypes.oneOfType([PropTypes.object]),
    stats: PropTypes.oneOfType([PropTypes.object]),
};

export default LatestList;
